import { useContext } from "react";
import DataContext from "../../store/DataContext";
import Button from "../UI/Button";
import classes from "./Header.module.css";
const Header = () => {
  const {
    numberOfUnreadMessages,
    onReadMessage,
  } = useContext(DataContext);
  const readAllHandler = () => {
    onReadMessage();
  };
  return (
    <header className={classes.header}>
      <div>
        <h2>Notifications</h2>
        <h3 className={classes.unread_messages}>
          {numberOfUnreadMessages}
        </h3>
      </div>

      <Button onClick={readAllHandler}>
        Mark all as read
      </Button>
    </header>
  );
};

export default Header;
